import { render, staticRenderFns } from "./CurrentHeadCountCard.vue?vue&type=template&id=590b5b31"
import script from "./CurrentHeadCountCard.vue?vue&type=script&lang=js"
export * from "./CurrentHeadCountCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports